<form [formGroup]="form" (ngSubmit)="onSave()" (keydown.enter)="$event.preventDefault()">
	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'scim-administration.policies.update.title' | translate }}
	</h1>

	<mat-dialog-content>
		<div class="optional-form-fields">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'scim-administration.policies.create.name' | translate }}
				</mat-label>
				<input matInput formControlName="name" [placeholder]="'scim-administration.policies.create.namePlaceholder' | translate" maxlength="60" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'scim-administration.policies.create.description' | translate }}
				</mat-label>
				<input matInput formControlName="description" [placeholder]="'scim-administration.policies.create.descriptionPlaceholder' | translate" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'scim-administration.policies.create.level' | translate }}
				</mat-label>
				<input matInput [value]="policy.type" disabled />
			</mat-form-field>
		</div>

		<div class="permissions-section">
			<label class="mat-body-1">
				<strong>{{ 'scim-administration.policies.create.permissions' | translate }}</strong>
			</label>
			@if (isLoadingPermissions) {
				<div style="padding: 12px 0">
					<img class="spinner" src="./assets/spinner2.gif" style="width: 24px; height: 24px" />
				</div>
			}
			@for (group of permissionGroups; track group.service.name) {
				<div class="permission-group">
					<h4 style="margin: 16px 0 8px 0; padding: 8px 12px; background-color: #f0f0f0; border-radius: 4px; border-left: 3px solid #3f51b5; font-weight: 600">
						{{ group.service.name }}
					</h4>
					@for (permission of group.permissions; track permission.id) {
						<div class="permission-checkbox">
							<mat-checkbox [checked]="isPermissionSelected(permission.id)" (change)="togglePermission(permission.id)">
								{{ permission.name }}
							</mat-checkbox>
						</div>
					}
				</div>
			}
		</div>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="isLoading || form.invalid">
				{{ 'scim-administration.policies.update.submit' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'scim-administration.policies.create.cancel' | translate }}
			</button>
		</div>
	</div>
</form>
